import { createContext } from 'react';
import type { CalendarContextT } from './useConfigCalendarCTX.js';

export const defaultCalendarContext = {} as CalendarContextT;

/** Context for cross component communication */
export const CalendarContext = createContext<CalendarContextT>(defaultCalendarContext);

export default CalendarContext;
